module.exports = __webpack_public_path__ + "static/img/鼎新.682bf3b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/合作夥伴/鼎新.jpg?20181011
// module id = U17M
// module chunks = 1